<div app-layout class="w-full pb-4">
  <div class="mb-10 flex w-full items-center justify-between rounded-lg bg-theme-500 p-5 shadow shadow-black/40">
    <div class="w-8/12 md:w-10/12">
      <div class="flex items-center justify-start gap-3">
        <svg-icon class="w-6 text-white" src="assets/icons/icon-dashboard.svg"></svg-icon>
        <div translate class="text-lg font-semibold text-white">trilhas.dashboard.painel-progresso</div>
        <div
          *ngIf="totalCourses"
          class="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black shadow shadow-black/40"
        >
          {{ totalCourses }}
        </div>
      </div>
    </div>
    <div class="form-group w-4/12 md:w-2/12">
      <ng-select
        app-select
        bindValue="id"
        bindLabel="nome"
        name="year"
        [formControl]="yearsCtrl"
        [items]="years"
        [placeholder]="'geral.ano' | translate"
        [notFoundText]="'modulos.materiais-didaticos.nenhum-ano' | translate"
        [searchable]="false"
        [clearable]="false"
      >
      </ng-select>
    </div>
  </div>
  <ng-container *ngIf="data$ | async as data; else noData">
    <div class="flex h-[75vh] flex-col items-center justify-between gap-4 overflow-y-auto md:flex-row md:items-start">
      <div class="h-[60vh] w-full overflow-y-auto md:h-[75vh] md:w-6/12 3xl:w-7/12">
        <div class="flex w-full flex-col items-start justify-between gap-4 3xl:flex-row">
          <app-card class="w-full">
            <div
              app-card-header
              class="flex flex-row! items-center gap-4 !rounded-t-lg bg-[#4adf80] pb-5 shadow shadow-black/40"
            >
              <svg-icon class="w-6 text-white" src="assets/icons/icon-check.svg"></svg-icon>
              <h1 translate class="text-md font-semibold text-theme-950">trilhas.dashboard.cursos-realizados</h1>
              <div
                class="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black shadow shadow-black/40"
              >
                {{ data.concluidos.total }}
              </div>
            </div>
            <div app-card-content class="flex max-h-[20rem] w-full flex-col gap-2 overflow-y-auto pt-5 3xl:h-[23rem]">
              <div *ngIf="data.concluidos.cursos.length; else empty" class="w-full bg-theme-50 p-2 text-theme-900">
                <table app-table class="w-full border-separate border-spacing-0.5 border-spacing-y-0.5">
                  <thead class="text-center">
                    <tr>
                      <th
                        translate
                        class="w-5/12 !bg-theme-400 p-2 text-left text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.curso
                      </th>
                      <th
                        translate
                        class="w-4/12 !bg-theme-400 p-2 pl-4 text-center text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.data-conclusao
                      </th>
                      <th
                        translate
                        app-table-cell
                        class="w-3/12 !bg-theme-400 p-2 pl-4 text-center text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.certificado
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let curso of data.concluidos.cursos" class="group odd:!bg-white even:!bg-theme-50">
                      <td class="border-b border-b-theme-200 !p-4 text-left group-hover:!bg-theme-200">
                        <div class="flex items-center gap-2">
                          <div class="border-1 flex w-max !rounded-full bg-white/80 !p-1 shadow-sm shadow-black/40">
                            <div class="self-center">
                              <img
                                [src]="curso.thumbnail"
                                onerror="src='assets/images/default.png'"
                                alt="img"
                                class="w-12 rounded-full"
                              />
                            </div>
                          </div>
                          <div class="w-full">
                            <p class="text-base font-semibold">{{ curso.titulo }}</p>
                          </div>
                        </div>
                      </td>
                      <td class="border-b border-b-theme-200 !p-4 text-center group-hover:!bg-theme-200">
                        {{ curso.data_conclusao | dateTranslate }}
                      </td>
                      <td class="border-b border-b-theme-200 !p-4 text-center group-hover:!bg-theme-200">
                        <div
                          *ngIf="curso.emite_certificado; else semCertificado"
                          class="flex flex-col items-center justify-between"
                        >
                          <button
                            (click)="onRedeemCertificate(curso)"
                            class="group/certificate flex items-center justify-center !bg-base-status-info-50 hover:!bg-base-status-info-50"
                            app-flat-button
                            type="button"
                            app-tooltip
                          >
                            <svg-icon class="flex w-8 text-blue-400" src="assets/icons/icon-certified.svg"> </svg-icon>
                          </button>
                        </div>
                        <ng-template #semCertificado>-</ng-template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div app-card-footer></div>
          </app-card>
          <app-card class="w-full">
            <div
              app-card-header
              class="flex flex-row! items-center gap-4 !rounded-t-lg bg-[#61a6fb] pb-5 shadow shadow-black/40"
            >
              <svg-icon class="w-6 text-white" src="assets/icons/icon-unlocked.svg"></svg-icon>
              <h1 translate class="text-md font-semibold text-theme-950">trilhas.dashboard.cursos-andamento</h1>
              <div
                class="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black shadow shadow-black/40"
              >
                {{ data.em_andamento.total }}
              </div>
            </div>
            <div app-card-content class="flex h-[20rem] w-full flex-col gap-2 overflow-y-auto pt-5 3xl:h-[23rem]">
              <div *ngIf="data.em_andamento.cursos.length; else empty" class="w-full bg-theme-50 p-2 text-theme-900">
                <table app-table class="w-full border-separate border-spacing-0.5 border-spacing-y-0.5">
                  <thead class="text-center">
                    <tr>
                      <th
                        translate
                        class="w-5/12 !bg-theme-400 p-2 text-left text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.curso
                      </th>
                      <th
                        translate
                        class="w-4/12 !bg-theme-400 p-2 pl-4 text-center text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.data-inicio
                      </th>
                      <th
                        translate
                        app-table-cell
                        class="w-3/12 !bg-theme-400 p-2 pl-4 text-center text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.progresso
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let curso of data.em_andamento.cursos" class="group odd:!bg-white even:!bg-theme-50">
                      <td class="border-b border-b-theme-200 !p-4 text-left group-hover:!bg-theme-200">
                        <div class="flex items-center gap-2">
                          <div class="border-1 flex w-max !rounded-full bg-white/80 !p-1 shadow-sm shadow-black/40">
                            <div class="self-center">
                              <img
                                [src]="curso.thumbnail"
                                onerror="src='assets/images/default.png'"
                                alt="img"
                                class="w-12 rounded-full"
                              />
                            </div>
                          </div>
                          <div class="w-full">
                            <p class="text-base font-semibold">{{ curso.titulo }}</p>
                          </div>
                        </div>
                      </td>
                      <td class="border-b border-b-theme-200 !p-4 text-center group-hover:!bg-theme-200">
                        {{ curso.data_inicio | dateTranslate }}
                      </td>
                      <td class="border-b border-b-theme-200 !p-4 text-center group-hover:!bg-theme-200">
                        <div class="group/concluidos flex flex-col items-center justify-center">
                          <div class="relative h-12 w-12">
                            <svg class="h-full w-full" viewBox="0 0 100 100">
                              <circle
                                class="stroke-current text-gray-200"
                                stroke-width="8"
                                cx="50"
                                cy="50"
                                r="40"
                                fill="transparent"
                              ></circle>
                              <circle
                                class="progress-ring__circle stroke-current text-blue-500"
                                stroke-width="8"
                                stroke-linecap="round"
                                cx="50"
                                cy="50"
                                r="40"
                                fill="transparent"
                                [attr.stroke-dasharray]="circumference"
                                [attr.stroke-dashoffset]="onStokeDashoffset(curso.progresso)"
                              ></circle>
                            </svg>
                          </div>
                          <p class="text-center font-goldplay text-base text-theme-900">{{ curso.progresso }}%</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div app-card-footer></div>
          </app-card>
        </div>
        <div class="mt-4 flex w-full flex-col items-center justify-between gap-4 3xl:flex-row">
          <app-card class="w-full">
            <div
              app-card-header
              class="flex flex-row! items-center gap-4 !rounded-t-lg bg-[#f97172] pb-5 shadow shadow-black/40"
            >
              <svg-icon class="w-8 text-white" src="assets/icons/icon-lock.svg"></svg-icon>
              <h1 translate class="text-md font-semibold text-theme-950">trilhas.dashboard.cursos-encerrados</h1>
              <div
                class="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black shadow shadow-black/40"
              >
                {{ data.encerrados.total }}
              </div>
            </div>
            <div app-card-content class="flex h-[20rem] w-full flex-col gap-2 overflow-y-auto pt-5 3xl:h-[23rem]">
              <div *ngIf="data.encerrados.cursos.length; else empty" class="w-full bg-theme-50 p-2 text-theme-900">
                <table app-table class="w-full border-separate border-spacing-0.5 border-spacing-y-0.5">
                  <thead class="text-center">
                    <tr>
                      <th
                        translate
                        class="w-8/12 !bg-theme-400 p-2 text-left text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.curso
                      </th>
                      <th
                        translate
                        class="w-4/12 !bg-theme-400 p-2 pl-4 text-center text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.data-encerramento
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let curso of data.encerrados.cursos" class="group odd:!bg-white even:!bg-theme-50">
                      <td class="border-b border-b-theme-200 !p-4 text-left group-hover:!bg-theme-200">
                        <div class="flex items-center gap-2">
                          <div class="border-1 flex w-max !rounded-full bg-white/80 !p-1 shadow-sm shadow-black/40">
                            <div class="self-center">
                              <img
                                [src]="curso.thumbnail"
                                onerror="src='assets/images/default.png'"
                                alt="img"
                                class="w-12 rounded-full"
                              />
                            </div>
                          </div>
                          <div class="w-full">
                            <p class="text-base font-semibold">{{ curso.titulo }}</p>
                          </div>
                        </div>
                      </td>
                      <td class="border-b border-b-theme-200 !p-4 text-center group-hover:!bg-theme-200">
                        {{ curso.evento.data_fim | dateTranslate }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div app-card-footer></div>
          </app-card>
          <app-card class="w-full">
            <div
              app-card-header
              class="flex flex-row! items-center gap-4 !rounded-t-lg bg-[#facc16] pb-5 shadow shadow-black/40"
            >
              <svg-icon class="w-6 text-white" src="assets/icons/icon-block.svg"></svg-icon>
              <h1 translate class="text-md font-semibold text-theme-950">trilhas.dashboard.cursos-nao-concluidos</h1>
              <div
                class="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black shadow shadow-black/40"
              >
                {{ data.nao_concluidos.total }}
              </div>
            </div>
            <div app-card-content class="flex h-[20rem] w-full flex-col gap-2 overflow-y-auto pt-5 3xl:h-[23rem]">
              <div *ngIf="data.nao_concluidos.cursos.length; else empty" class="w-full bg-theme-50 p-2 text-theme-900">
                <table app-table class="w-full border-separate border-spacing-0.5 border-spacing-y-0.5">
                  <thead class="text-center">
                    <tr>
                      <th
                        translate
                        class="w-5/12 !bg-theme-400 p-2 text-left text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.curso
                      </th>
                      <th
                        translate
                        class="w-4/12 !bg-theme-400 p-2 pl-4 text-center text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.data-encerramento
                      </th>
                      <th
                        translate
                        app-table-cell
                        class="w-3/12 !bg-theme-400 p-2 pl-4 text-center text-sm font-semibold uppercase text-theme-contrast first:rounded-l-lg first:pl-3 last:rounded-r-lg last:pr-3 [&:is(th)]:bg-theme-500 [&:is(th)]:text-theme-contrast [&:not(th)]:bg-white"
                      >
                        trilhas.dashboard.parcial
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let curso of data.nao_concluidos.cursos" class="group odd:!bg-white even:!bg-theme-50">
                      <td class="border-b border-b-theme-200 !p-4 text-left group-hover:!bg-theme-200">
                        <div class="flex items-center gap-2">
                          <div class="border-1 flex w-max !rounded-full bg-white/80 !p-1 shadow-sm shadow-black/40">
                            <div class="self-center">
                              <img
                                [src]="curso.thumbnail"
                                onerror="src='assets/images/default.png'"
                                alt="img"
                                class="w-12 rounded-full"
                              />
                            </div>
                          </div>
                          <div class="w-full">
                            <p class="text-base font-semibold">{{ curso.titulo }}</p>
                          </div>
                        </div>
                      </td>
                      <td class="border-b border-b-theme-200 !p-4 text-center group-hover:!bg-theme-200">
                        {{ curso.evento.data_fim | dateTranslate }}
                      </td>
                      <td class="border-b border-b-theme-200 !p-4 text-center group-hover:!bg-theme-200">
                        <div class="group/concluidos flex flex-col items-center justify-center">
                          <div class="relative h-12 w-12">
                            <svg class="h-full w-full" viewBox="0 0 100 100">
                              <circle
                                class="stroke-current text-gray-200"
                                stroke-width="8"
                                cx="50"
                                cy="50"
                                r="40"
                                fill="transparent"
                              ></circle>
                              <circle
                                class="progress-ring__circle stroke-current text-[#facc16]"
                                stroke-width="8"
                                stroke-linecap="round"
                                cx="50"
                                cy="50"
                                r="40"
                                fill="transparent"
                                [attr.stroke-dasharray]="circumference"
                                [attr.stroke-dashoffset]="onStokeDashoffset(curso.progresso)"
                              ></circle>
                            </svg>
                          </div>
                          <p class="text-center font-goldplay text-base text-theme-900">{{ curso.progresso }}%</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div app-card-footer></div>
          </app-card>
          <ng-template #empty>
            <div class="h-[25rem]">
              <app-jumbotron translate> trilhas.dashboard.nenhum-curso-listado </app-jumbotron>
            </div>
          </ng-template>
        </div>
      </div>
      <div app-card class="h-[40vh] w-full rounded-xl bg-white shadow shadow-black/40 md:h-[75vh] md:w-6/12 3xl:w-5/12">
        <div
          app-card-header
          class="flex flex-row! items-center gap-5 rounded-t-lg bg-theme-400 pb-5 shadow shadow-black/40"
        >
          <svg-icon class="w-6 text-theme-50 md:w-8" src="assets/icons/icon-chart.svg"></svg-icon>
          <h1 translate class="text-md font-semibold text-theme-50">trilhas.dashboard.grafico-progresso</h1>
        </div>
        <div app-card-content class="!mb-20 p-10 md:p-36">
          <ng-container *ngIf="chartData">
            <div class="flex items-center justify-center">
              <ngx-charts-bar-vertical
                [legendPosition]="'below'"
                [view]="view"
                [scheme]="colorScheme"
                [results]="chartData"
                [gradient]="false"
                [xAxis]="true"
                [barPadding]="30"
                [noBarWhenZero]="true"
                [yAxis]="true"
                [legend]="legend"
                [legendTitle]="'trilhas.relatorio.legenda' | translate"
                [showXAxisLabel]="true"
                [showDataLabel]="true"
                [showYAxisLabel]="true"
              >
              </ngx-charts-bar-vertical>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #noData>
    <ng-container *ngIf="loading; else empty">
      <div class="flex !h-[200px] items-center justify-center">
        <app-skeleton class="block !h-full w-full"></app-skeleton>
      </div>
    </ng-container>
    <ng-template #empty>
      <div class="flex !h-[200px] items-center justify-center">
        <app-jumbotron translate> trilhas.dashboard.nenhum-curso-listado </app-jumbotron>
      </div>
    </ng-template>
  </ng-template>
</div>
